import { Button } from "../../components/ui/button";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../components/ui/radio-group";
import { Input } from "../../components/ui/input";
import {PictureUploader} from "./PictureUploader";
import LiveSearchCombo from "../LiveSearchCombo";
import { searchUsers, searchBusinesses } from "../services/employees";
import {
  showPictureUploader,
  pictureHint,
} from "../hooks/useEmployeesValidation";

export const IdentitySection = ({ employee, setField, userSearch, bizSearch, businessId }) => {
    const setIdentityType = (val) => {
      if (val === employee.identityType) return;   // nothing to do
      setField("identityType", val);
    // …and clear whichever link no longer applies
    if (val === "USER") {
      setField("linkedBusiness", null);
    } else if (val === "BUSINESS") {
      setField("linkedUser", null);
    } else {
      // also clear both when switching to CUSTOM
      setField("linkedUser", null);
      setField("linkedBusiness", null);
    }
  };
  const clearLinkedUser = () => {
    setField("linkedUser", null);
    setField("fullName", "");
  };

  const setCustom = (key, val) =>
    setField(key, val); // fullName, email, picture stored top-level

  return (
    <div className="space-y-4">
      <p className="font-medium">Identity type</p>
      <RadioGroup
        value={employee.identityType}
        onValueChange={setIdentityType}
        className="flex gap-6 flex-wrap"
      >
        <RadioGroupItem value="USER" id={`${employee.id}-iden-user`}>
          Link Trippin user
        </RadioGroupItem>
        {employee.roleType === "MANAGING_ACCOUNT" && (

          <RadioGroupItem value="BUSINESS" id={`${employee.id}-iden-biz`}>
            Link Business
          </RadioGroupItem>
        )}
        <RadioGroupItem value="CUSTOM" id={`${employee.id}-iden-custom`}>
          Custom employee
        </RadioGroupItem>
      </RadioGroup>
     {employee.identityType === "USER" && !employee.linkedUser && (
       <LiveSearchCombo
         value={employee.linkedUser}
         placeholder="Search Trippin user…"
         searchFn={userSearch}
         onSelect={(u) => {
           setField("linkedUser", u);
           setField("fullName", u.label);     // auto-fill name
         }}
       />
     )}

     {/* --- Selected entity chip (USER or BUSINESS) --- */}
     {["USER", "BUSINESS"].includes(employee.identityType) &&
      (employee.linkedUser || employee.linkedBusiness) && (
        <div className="flex items-center gap-2 bg-muted rounded px-2 py-1 w-fit">
          {/** avatar **/}
          {(employee.linkedUser?.avatar || employee.linkedBusiness?.avatar) && (
            <img
              src={employee.linkedUser?.avatar ?? employee.linkedBusiness?.avatar}
              alt="avatar"
              className="h-5 w-5 rounded-full object-cover"
            />
          )}
          {/** label **/}
          <span className="text-sm font-medium">
            {employee.linkedUser?.username ?? employee.linkedBusiness?.name}
          </span>
          <button onClick={clearLinkedUser /* same fn works for both */} className="text-muted-foreground">
            ×
          </button>
        </div>
     )}


      {employee.identityType === "BUSINESS" && (
        <LiveSearchCombo
          value={employee.linkedBusiness}
          placeholder="Search business…"
          searchFn={bizSearch}
          onSelect={(b) =>{
            setField("linkedBusiness", b);
            setField("fullName", b.label);
          }}
        />
      )}
      {/* CUSTOM employee form */}
      {employee.identityType === "CUSTOM" && (
        <div className="space-y-4">
          <Input
            placeholder="Full name"
            value={employee.fullName}
            onChange={(e) => {
                e.stopPropagation();
              setCustom("fullName", e.target.value)}}
              onClick={(e) => e.stopPropagation()}
              onFocus={(e) => e.stopPropagation()}
          />
          <Input
            type="email"
            placeholder="Email"
            value={employee.email}
            onChange={(e) => {
                e.stopPropagation();
                setCustom("email", e.target.value)}}
                onClick={(e) => e.stopPropagation()}
                onFocus={(e) => e.stopPropagation()}
          />
        </div>
      )}
      {showPictureUploader(employee) && (
        <div className="space-y-1">
         <PictureUploader
            picture={employee.picture}
            businessId={businessId}
            onUpload={(file) => setField("picture", file)}   // store File for now
            onRemove={() => setField("picture", null)}
          />
          <p className="text-xs text-muted-foreground">{pictureHint}</p>
        </div>
      )}
    </div>
  );
};